export const isPresent = (val) =>
  ![null, undefined, NaN, "undefined", "null"].includes(val);
